import api from "@/api/axios";

export default {
  getOtps(params) {
    return api.get("/otps", { params });
  },

  resendOtp(userId, data) {
    return api.post(`/otps/${userId}/resend`, data);
  },

  deleteOtps(userId) {
    return api.delete(`/otps/${userId}`);
  },
};
